
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useLanguage } from '@/contexts/LanguageContext';

interface AlertTypeFilterProps {
  selectedType: string | null;
  onSelectType: (type: string | null) => void;
}

export const AlertTypeFilter: React.FC<AlertTypeFilterProps> = ({
  selectedType,
  onSelectType
}) => {
  const { t } = useLanguage();

  const alertTypes = [
    { value: null, label: t('allAlerts') || 'All Alerts' },
    { value: 'INSUFFICIENT_HOURS', label: t('insufficientHours') || 'Insufficient Hours' },
    { value: 'UNASSIGNED_SCHEDULE', label: t('unassignedSchedule') || 'Unassigned Schedule' },
    { value: 'night_morning_shift', label: t('nightMorningShift') || 'Night-Morning Shift' },
    { value: 'insufficient_rest', label: t('insufficientRest') || 'Insufficient Rest' },
    { value: 'visibility_status', label: t('visibilityStatus') || 'Visibility Status' },
    { value: 'missing_template_shifts', label: t('missingTemplateShifts') || 'Missing Template Shifts' }
  ];

  return (
    <div className="flex flex-col space-y-2">
      <label className="text-sm font-medium text-muted-foreground">
        {t('filterByAlertType') || 'Filter by Alert Type'}
      </label>
      <Select 
        value={selectedType || 'all'} 
        onValueChange={(value) => onSelectType(value === 'all' ? null : value)}
      >
        <SelectTrigger className="w-64">
          <SelectValue placeholder={t('selectAlertType') || 'Select alert type'} />
        </SelectTrigger>
        <SelectContent>
          {alertTypes.map((type) => (
            <SelectItem 
              key={type.value || 'all'} 
              value={type.value || 'all'}
            >
              {type.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
